import script from "./PopupUploadFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupUploadFiles.vue?vue&type=script&setup=true&lang=js"

import "./PopupUploadFiles.vue?vue&type=style&index=0&id=12d712d4&lang=scss"

const __exports__ = script;

export default __exports__